import { Action } from 'common/interfaces/root';
import { actionTypes } from '../actions/action-types';

const initialState: Conversions.Conv.ConversionState = {
  loading: false,
  error: null,
  data: null,
};

export default (
  state: Conversions.Conv.ConversionState = initialState,
  { type, payload }: Action
): Conversions.Conv.ConversionState => {
  switch (type) {
    case actionTypes.conversions.GET_CONVERSIONS:
      return { ...state, loading: true };
    case actionTypes.conversions.GET_CONVERSIONS_SUCCESS:
      return { ...state, loading: false, data: payload };
    case actionTypes.conversions.GET_CONVERSIONS_ERROR:
      return { ...state, loading: false, error: payload };
    default:
      return state;
  }
};
